module.exports = __webpack_public_path__ + "static/img/right-num-row-0.378025ac.png";